import type { Match } from '@repo/types';

export function formatMatchDate(date: string): string {
  const parsed = new Date(`${date}T00:00:00`);
  return parsed.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
}

type MatchListProps = {
  title: string;
  matches: Match[];
  showScore: boolean;
};

/** Compact match list shared by the fixtures and results mega embeds. */
export function MatchList({ title, matches, showScore }: MatchListProps) {
  return (
    <div className="nav__mega-comp">
      <h6 className="nav__mega-title">{title}</h6>
      <ul className="nav__fixlist">
        {matches.map((match) => (
          <li key={match.id} className="text-3xs">
            <span className="nav__fixlist-date text-3xs">{formatMatchDate(match.date)}</span>
            <span className="nav__fixlist-teams">
              <span>{match.homeTeam.shortName || match.homeTeam.fullName}</span>
              <span>{match.awayTeam.shortName || match.awayTeam.fullName}</span>
            </span>
            {showScore ? (
              <span className="nav__fixlist-score">
                {match.score.current.home}–{match.score.current.away}
              </span>
            ) : (
              <span className="nav__fixlist-ko text-3xs">{match.time ? match.time.slice(0, 5) : 'TBC'}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
